import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import { useExternalAccessRights } from 'common/hooks';
import { usePermissions } from 'common/wolt-permissions';
import { hasVenueInsightsPermission } from 'common/wolt-permissions/permissionUtils';

export const useVenueInsightsPermissions = (venue: Venue) => {
  const permissions = usePermissions();
  const externalAccessRights = useExternalAccessRights();

  return hasVenueInsightsPermission(permissions, externalAccessRights, venue);
};
